import { render, staticRenderFns } from "./CompanyEdit.vue?vue&type=template&id=5c878ff6&scoped=true"
import script from "./CompanyEdit.vue?vue&type=script&lang=js"
export * from "./CompanyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c878ff6",
  null
  
)

export default component.exports